import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { FEATURES, SCREENS } from '../../data/landingContent';

export const reveal = (i = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
  transition: { duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] },
});

const FeatureCard = ({ f, i }) => {
  const Icon = Icons[f.icon];
  return (
    <motion.article {...reveal(i)} className={`lp-card${f.big ? ' lp-card--big' : ''}`} data-testid={`feature-card-${f.key}`}>
      <span className="lp-card__icon"><Icon size={f.big ? 26 : 20} /></span>
      <h3>{f.title}</h3>
      <p>{f.body}</p>
    </motion.article>
  );
};

export const Features = () => (
  <section id="features" className="lp-section lp-section--paper" data-testid="features-section">
    <div className="lp-wrap">
      <motion.div {...reveal()} className="lp-head">
        <span className="lp-eyebrow">10 tools · one app</span>
        <h2 className="lp-h2">Everything you scribble on folded paper, finally in your pocket.</h2>
      </motion.div>
      <div className="lp-bento">
        {FEATURES.map((f, i) => <FeatureCard key={f.key} f={f} i={i} />)}
      </div>
    </div>
  </section>
);

export const Screens = () => (
  <section className="lp-section lp-section--dark" data-testid="screens-section">
    <div className="lp-wrap">
      <motion.div {...reveal()} className="lp-head">
        <span className="lp-eyebrow lp-eyebrow--amber">See it on shift</span>
        <h2 className="lp-h2">Built for a 12-hour shift, not a demo.</h2>
      </motion.div>
    </div>
    <div className="lp-rail" data-testid="screens-rail">
      {SCREENS.map((s, i) => (
        <motion.figure {...reveal(i)} key={s.src} className="lp-rail__item" data-testid={`screen-${i + 1}`}>
          <img src={s.src} alt={s.alt} loading="lazy" width="645" height="1398" />
          <figcaption>{s.caption}</figcaption>
        </motion.figure>
      ))}
    </div>
  </section>
);
